<template>
  <gj-modal
      :visible.sync="modalVisible"
      no-padding
      global
      :class="{'global-width': clientWidth > 1600} "
  >
    <template #content>
      <app-version-announcement-template
          @close="cancel"
          :data="data"
      ></app-version-announcement-template>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../../../../minxins";
  import AppVersionAnnouncementTemplate from "./template/version-announcement-template";
  //取消步骤引导接口
  // import {batchMarkSysMessage} from "@/api/message";
  export default {
    name: "version-announcement",
    components: {AppVersionAnnouncementTemplate},
    mixins: [modalMixIn, modalMixIn],
    props: {
      data: {},
    },
    mounted() {
      //接口取消步骤引导
      // batchMarkSysMessage(this.data.id)
    },
    methods:{
      cancel(){
        this.$emit('close')
        this.modalVisible = false
      }
    }
  }
</script>

<style scoped>
  .global-width {}

  .global-width /deep/ .gj-modal--full .el-dialog {
    height: calc(100vh - 200px)!important;
    width: 1000px!important;
  }

  /deep/ .el-dialog {
    overflow-y: auto;
  }

  /deep/ .el-dialog__body > div{
    height: 100%;
  }
</style>
